import React, {PropTypes} from 'react';

const TeamOwnedVirtualEntryTracker = ({
  childTeamOwnedVirtualEntries,
  childVirtualEntryEvents,
  parentTeamOwnedVirtualEntries,
  parentVirtualEntryEvents,
  onRemoveUnassignedVirtualEntries
}) => (
  <div>
    { parentVirtualEntryEvents.length > 0 || childVirtualEntryEvents.length > 0 
    ?
      <table className="info-summary">
        <thead>
          <tr>
            <th>Virtual Event Name</th>
            <th>Available Entries</th>
            <th>Total Entries</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {parentVirtualEntryEvents.map((entry, index) => (
            <tr key={index}>
              <td>{entry.name}</td>
              <td>{parentTeamOwnedVirtualEntries.filter(x => x.virtualEventName == entry.name && x.teamEntryId == null && x.id.length < 36).length}</td>
              <td>{parentTeamOwnedVirtualEntries.filter(x => x.virtualEventName == entry.name && x.id.length < 36).length}</td>
              <td>
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-link"
                    title="Remove unassigned virtual entries from cart"
                    disabled={parentTeamOwnedVirtualEntries.filter(x => x.virtualEventName == entry.name && x.teamEntryId == null).length == 0}
                    onClick={() => onRemoveUnassignedVirtualEntries(true, entry.name, 'parent', parentTeamOwnedVirtualEntries.filter(x => x.virtualEventName == entry.name && x.teamEntryId == null).length)}
                  ><i className="fa fa-trash-o" /></button>
                </div>
              </td>
            </tr>
          ))}
          {childVirtualEntryEvents.filter((item, pos, self) => { return self.findIndex(x => x.name === item.name) == pos;}).map((entry, index) => (
            childTeamOwnedVirtualEntries.filter(x => x.id.length < 36).length > 0
            ? 
            <tr key={index}>
              <td>{entry.name}</td>
              <td>{childTeamOwnedVirtualEntries.filter(x => x.virtualEventName == entry.name && x.parentTeamEntryId == null && x.id.length < 36).length}</td>
              <td>{childTeamOwnedVirtualEntries.filter(x => x.virtualEventName == entry.name && x.id.length < 36).length}</td>
              <td>
                <div className="text-right">
                  <button
                    type="button"
                    className="btn btn-link"
                    title="Remove unassigned virtual entries from cart"
                    disabled={childTeamOwnedVirtualEntries.filter(x => x.virtualEventName == entry.name && x.parentTeamEntryId == null).length == 0}
                    onClick={() => onRemoveUnassignedVirtualEntries(true, entry.name, 'child', childTeamOwnedVirtualEntries.filter(x => x.virtualEventName == entry.name && x.parentTeamEntryId == null).length)}
                  ><i className="fa fa-trash-o" /></button>
                </div>
              </td>
            </tr>
            : null
          ))}
        </tbody>
      </table>
    : null}
  </div>
);

TeamOwnedVirtualEntryTracker.propTypes = {
  childTeamOwnedVirtualEntries: PropTypes.arrayOf(PropTypes.object),
  childVirtualEntryEvents: PropTypes.arrayOf(PropTypes.object),
  parentTeamOwnedVirtualEntries: PropTypes.arrayOf(PropTypes.object),
  parentVirtualEntryEvents: PropTypes.arrayOf(PropTypes.object),
  onRemoveUnassignedVirtualEntries: PropTypes.func
};

TeamOwnedVirtualEntryTracker.defaultProps = {
  childTeamOwnedVirtualEntries: [],
  childVirtualEntryEvents: [],
  parentTeamOwnedVirtualEntries: [],
  parentVirtualEntryEvents: []
};

export default TeamOwnedVirtualEntryTracker;



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/TeamOwnedVirtualEntryTracker.jsx